import React from 'react';
import { Dispatch } from 'architecture'
import _ from 'lodash'
import DatePicker from 'react-datepicker';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { faTags } from '@fortawesome/free-solid-svg-icons'
import { faCog } from '@fortawesome/free-solid-svg-icons'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { faBan } from '@fortawesome/free-solid-svg-icons'
//import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import Linkify from 'react-linkify'
import DropZone from 'react-dropzone'
import moment from 'moment'

import TagInput from './TagInput/TagInput'
import Auth from './Auth'

import logo from '../media/logo.svg'
import Tag from './TagInput/Tag'
import Sidebar from './Sidebar'
import TagEditor from './TagEditor'
import Stream from './Stream'

import "react-datepicker/dist/react-datepicker.css";

//Every created instance shows up in feed
//Every modify shows up in feed (but can be condensed into just the instance)

export default (props) => {
  //const states = props.States && props.TagInput ? props.States : {}
  const tagInputs = props.TagInput ? props.TagInput : {}
  const search = props.Search ? props.Search : {}
  const streamInput = props.StreamInput ? props.StreamInput : {}
  const stateBuffer = props.StateBuffer ? props.StateBuffer : false
  const orderedStates = props.OrderedStates ? props.OrderedStates : {}
  const states = orderedStates.states ? orderedStates.states : {}
  const order = orderedStates.order ? orderedStates.order : []
  const open = props.Sidebar ? props.Sidebar.open : true
  const tagEditorOpen = props.Sidebar && props.Sidebar.TagEditor && props.Sidebar.TagEditor.open ? props.Sidebar.TagEditor.open : false

  return (
 
      <div className='avenir fixed w-100 vh-100 bg-transparent flex flex-column justify-between'
        style={{zIndex:10, flexBasis:'auto', height: props.Window.height}}>
          <div className='w-100 pv2 ph2 bg-gray bb b--dark-gray'>
            <div className='flex items-center'>
              <div className='pr3 f3 white pointer' onClick={(e) => Dispatch.nextAction('Sidebar', 'change')}>
                <FontAwesomeIcon icon={faTags}/>
              </div>
              <div className='center' style={{flexGrow:1}}>
                <TagInput {...props} data={{ ...search, target: 'Search' }}/>
              </div>
              <div className='pl3 f3 white pointer' 
                onClick={(e) => Dispatch.nextAction('auth', 'do', 'signOut')}>
              <FontAwesomeIcon icon={faCog}/>
              </div>
              </div>
          </div>
          
          <div className='flex overflow-y-hidden overflow-x-hidden' style={{flexGrow:1}}>
            {/* FIXME: Hack to fix google chrome */}
            
            { open ? 
              <Sidebar {...props}/>
              :
              null
            }
            { tagEditorOpen ?
              <TagEditor {...props}/>
              :
              null
            }
            { props.auth && props.auth.user ? 
            // <div className='' style={{flexGrow:1}}>
              <div id='stream' className='w-100 overflow-y-scroll overflow-x-hidden' style={{WebkitOverflowScrolling: 'touch'}}>
                <Stream {...props} />
              </div>
            :
            <div className='pb5 vh-100 w-100 mw7 avenir center flex justify-center items-center'>
              <Auth {...props} />
            </div>
            }

          </div>

          {/* </div> */}
          {/* <div className='bg-transparent' style={{flexShrink:1}}> 
            { props.Sidebar && props.Sidebar.open ? 
              <Sidebar {...props}/>
              :
              null
            }
              </div> */}

        <div className='w-100 pt2 pb2 bg-gray bt b--gray'>
          <div className='w-100 ph2 center flex items-center'>
            <div className='w-100 ph2 center'>
                <TagInput {...props} data={{...streamInput, target: 'StreamInput', type: 'stream'}} />
            </div>
            <div className='pl1 f3 green pointer'>
              <FontAwesomeIcon icon={faPlusCircle}/>
            </div>
          </div>
        </div>
      </div>

  )
}

// class MyDropzone extends React.Component {
//   onDrop = (acceptedFiles, rejectedFiles) => {
//     // Do something with files
//   }

//   render() {
//    return (
//      <DropZone onDrop={this.onDrop}>
//        {({getRootProps, getInputProps, isDragActive}) => {
//          return (
//            <div className='fixed w-100 vh-100' style={{top:0, left: 0, zIndex:1000}}
//              {...getRootProps()}
//            >
//              <input {...getInputProps()} />
//              { isDragActive ?
//                 <div className='fixed vh-100 w-100 bg-moon-gray o-50' style={{top:0, left: 0, zIndex:1000}}> </div>
//                  //<p>Drop files here...</p> :
//                 : <p>Try dropping some files here, or click to select files to upload.</p>
//              }
//            </div>
//          )
//        }}
//      </DropZone>
//    );
//  }
// }